import { useMemo } from 'react';

import { ProductsBlockKind } from '@mssgme/shared';
import { useElementTheme, useTheme } from '@mssgme/ui';

export const useModalThemes = (kind = ProductsBlockKind) => {
    const baseTheme = useTheme();
    const { theme, style } = useElementTheme({ baseTheme, elementPath: `blocks.${kind.toLowerCase()}`, compile: true });

    return useMemo(
        () => ({
            theme,
            style,
            // todo: find out why this is needed (`colors.background` vs `page.backgroundColor`)
            modalStyle: { ...style, backgroundColor: baseTheme.colors.background },
            contentStyle: { ...theme, ...style, backgroundColor: baseTheme.colors.background },
        }),
        [theme, style]
    );
};
